import { saveAs } from 'file-saver'

export const downloadFile = (blob: Blob, fileName: string) => {
  saveAs(blob, fileName)
}
